import * as React from 'react';
import './PageHeaderReturnButton.css';
import IconButton from '../../Buttons/IconButton/IconButton';
import Tooltip from '../../Tips/Tooltip/Tooltip';
import Chevron from '../../Icons/Chevron/Chevron';
export default function PageHeaderReturnButton(_ref) {
  var onClick = _ref.onClick,
    i18n = _ref.i18n,
    i18nKey = _ref.i18nKey;
  return /*#__PURE__*/React.createElement(Tooltip, {
    i18n: i18n,
    i18nKey: i18nKey
  }, function (_ref2) {
    var ref = _ref2.ref,
      labelledby = _ref2.labelledby,
      events = _ref2.events;
    return /*#__PURE__*/React.createElement(IconButton, Object.assign({
      ref: ref,
      "aria-labelledby": labelledby,
      onClick: onClick,
      className: "_dm-header-return _dm-header-return--button"
    }, events), /*#__PURE__*/React.createElement(Chevron, null));
  });
}